(function () {
  let productData = null;
  let lastVariantId = '';

  function norm(str) {
    return (str || '')
      .replace(/[：:]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getHandle() {
    const m = location.pathname.match(/\/products\/([^\/\?]+)/);
    return m ? m[1] : null;
  }

  async function loadProductData() {
    if (productData) return productData;

    const handle = getHandle();
    if (!handle) return null;

    try {
      const res = await fetch('/products/' + handle + '.js', {
        credentials: 'same-origin'
      });
      if (!res.ok) throw new Error('fetch failed');
      productData = await res.json();
      return productData;
    } catch (err) {
      console.warn('[SC] load product failed', err);
      return null;
    }
  }

  function getVariantIdInput() {
    return document.querySelector(
      'form[action*="/cart/add"] input[name="id"], input[name="id"]'
    );
  }

  function getCurrentVariantId() {
    const input = getVariantIdInput();
    return input ? (input.value || '').trim() : '';
  }

  function getCurrentVariant() {
    if (!productData || !productData.variants) return null;
    const id = getCurrentVariantId();
    if (!id) return null;
    return productData.variants.find(function (v) {
      return String(v.id) === String(id);
    }) || null;
  }

  function getOptionValue(variant, optionName) {
    if (!variant || !productData || !productData.options) return '';

    const idx = productData.options.findIndex(function (opt) {
      return norm(opt.name || opt) === norm(optionName);
    });

    if (idx === -1) return '';
    return (variant['option' + (idx + 1)] || '').trim();
  }

  function getExactPfLabel(optionName) {
    const labels = Array.from(
      document.querySelectorAll('.pf-variant-label[data-pf-type="OptionLabel"], .pf-variant-label')
    );

    return labels.find(function (el) {
      const raw = el.dataset.scBaseLabel || el.textContent || '';
      return norm(raw) === norm(optionName);
    }) || null;
  }

  function ensureBaseLabel(labelEl, baseText) {
    if (!labelEl.dataset.scBaseLabel) {
      labelEl.dataset.scBaseLabel = baseText;
    }
    return labelEl.dataset.scBaseLabel;
  }

  function getDisplayValue(optionName, value) {
    return value || '';
  }

  function renderLabel(optionName, value) {
    const labelEl = getExactPfLabel(optionName);
    if (!labelEl) return;

    const base = ensureBaseLabel(labelEl, optionName);
    const displayValue = getDisplayValue(optionName, value);

    labelEl.textContent = displayValue ? (base + ': ' + displayValue) : base;
  }

  async function render(force) {
    if (!document.querySelector('.pf-variant-label')) return;

    await loadProductData();
    if (!productData) return;

    const variantId = getCurrentVariantId();
    if (!variantId) return;

    if (!force && variantId === lastVariantId) return;

    const variant = getCurrentVariant();
    if (!variant) return;

    renderLabel('Color', getOptionValue(variant, 'Color'));
    renderLabel('Size', getOptionValue(variant, 'Size'));

    lastVariantId = variantId;
  }

  function bindVariantWatcher() {
    const idInput = getVariantIdInput();
    if (!idInput) return;

    let prev = idInput.value || '';

    const observer = new MutationObserver(function () {
      const next = idInput.value || '';
      if (next && next !== prev) {
        prev = next;
        render(true);
      }
    });

    observer.observe(idInput, {
      attributes: true,
      attributeFilter: ['value']
    });

    idInput.addEventListener('change', function () {
      const next = idInput.value || '';
      if (next && next !== prev) {
        prev = next;
        render(true);
      }
    });

    idInput.addEventListener('input', function () {
      const next = idInput.value || '';
      if (next && next !== prev) {
        prev = next;
        render(true);
      }
    });
  }

  function bindFallbackEvents() {
    document.addEventListener('change', function (e) {
      if (e.target.closest('.pf-option-swatches, form[action*="/cart/add"]')) {
        setTimeout(function () {
          render(false);
        }, 80);
      }
    }, true);

    document.addEventListener('click', function (e) {
      if (e.target.closest('.pf-option-swatches, .pf-variant-label')) {
        setTimeout(function () {
          render(false);
        }, 80);
      }
    }, true);
  }

  function init() {
    if (!location.pathname.includes('/products/')) return;

    render(true);
    setTimeout(function () {
      render(true);
    }, 300);

    bindVariantWatcher();
    bindFallbackEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();